import {
  ON_FORM_DATA_CHANGE,
  LEVEL_UP,
  LEVEL_DOWN,
  GET_AGE,
  SET_PASS,
  ON_ZIP_SEARCH_CHANGE,
  SET_LOADING,
  GET_ZIP_SITES,
  GET_BRAND_SITE,
  SUBMIT_DATA,
  GET_SITE_INFORMATION,
  GET_SITE_PROGRAM,
  GET_PROGRAMTYPESFORWEB,
  GET_SCHOOLTYPESFORWEB,
  APPLY_FILTER,
  GET_BRAND_DATA,
 RESET_INTEREST_FORM
} from "../types";

const InterestReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "SET_LEARNING_CENTER":
      return {
        ...state,
        learningCenterCoordinates: payload.coordinates,
        formData: {
          ...state.formData,
          learningCenterName: payload.name,
          learningCenterCharter: payload.charter,
          learningCenterAddress: payload.address,
          charterWebsite: payload.charterWebsite,
          charterContactnumber: payload.charterContactnumber,
          brandIcon: payload.brandIcon,
          principal: payload.principal,
          learningCenterId: payload.site_id,
        },
      };
    case GET_SITE_INFORMATION:
      let PrincipalObj = payload.people.find((p) => p.role == "Principal");
      return {
        ...state,
        siteInformation: payload,
        learningCenterCoordinates: payload.address.coordinates,
        formData: {
          ...state.formData,
          learningCenterName: payload.name,
          learningCenterCharter: payload.charter.name,
          learningCenterAddress: `${payload.address.address_1}, ${payload.address.city}, ${payload.address.state} ${payload.address.zip}`,
          charterWebsite: `${payload.charter.charterWebsite}`,
          charterContactnumber: `${payload.charter.charterContactnumber}`,
          brandIcon: `${payload.charter.brandIcon}`,
          principal: `${PrincipalObj ? PrincipalObj.person.name : "Unassigned"
            }`,
          site_id: `${payload._id}`,
        },
      };
    case GET_SITE_PROGRAM:
      return {
        ...state,
        Siteprogram: payload,
      };

    case GET_BRAND_DATA:
      return {
        ...state,
        brandName: payload,

      };

    case GET_PROGRAMTYPESFORWEB:
      return {
        ...state,
        programTypesforweb: payload,
      };

    case GET_SCHOOLTYPESFORWEB:
      return {
        ...state,
        schoolTypesforweb: payload,
      };
    case SUBMIT_DATA:
      return {
        ...state,
        formLevel: 6,
      };

    case ON_FORM_DATA_CHANGE:
      return {
        ...state,
        formData: {
          ...state.formData,
          [payload.name]: payload.value,
        },
      };

    case APPLY_FILTER:
      return {
        ...state,
        formData: {
          ...state.formData,
          learningCenterName: "",
          learningCenterCharter: "",
        },
      };
    case ON_ZIP_SEARCH_CHANGE:
      return {
        ...state,
        zipSearch: {
          ...state.zipSearch,
          [payload.name]: payload.value,
        },
      };
    case LEVEL_UP:
      return {
        ...state,
        formLevel:
          state.formLevel === 0 && state.age > 17
            ? 2
            : state.formLevel === 3 && state.formData.sameAddress
              ? 5
              : state.formLevel < 5
                ? state.formLevel + 1
                : state.formLevel,
      };
    case LEVEL_DOWN:
      return {
        ...state,
        formLevel:
          state.formLevel === 2 && state.age > 17
            ? 0
            : state.formLevel === 5 && state.formData.sameAddress
              ? 3
              : state.preSelected && state.formLevel === 0
                ? 0
                : state.formLevel > 0
                  ? state.formLevel - 1
                  : state.formLevel,
      };
    case GET_AGE:
      return {
        ...state,
        age: payload,
      };
    case SET_PASS:
      return {
        ...state,
        pass: { ...state.pass, [payload.name]: payload.value },
      };
    case SET_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case GET_ZIP_SITES:
      if (payload.zipCoordinates) {
        return {
          ...state,
          loading: false,
          zipCoordinates: payload.zipCoordinates,
          zipSites:payload.data,
        };
      } else if (payload.stateCoordinates) {
        let sortedStateSites = payload.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        return {
          ...state,
          loading: false,
          stateCoordinates: payload.stateCoordinates,
          stateSites: sortedStateSites,
        };
      } else {

        return {
          ...state,
          loading: false,
          stateSites: payload.data,
        };
      }



    case GET_BRAND_SITE:

      return {
        ...state,
        brandSites: payload,

      };

    case "PRE_SELECTED_SITE":
      return {
        ...state,
        formLevel: 0,
        formData: { ...state.formData, learningCenter: payload },
        preSelected: true,
        charterBrandName: payload && payload.split(" - ")[1],
      };
    case "PRE_SELECTED_CHARTER":
      return {
        ...state,
        charterBrandName: payload,
      };
    case "SET_CAMPAIGN_TYPE":
      return {
        ...state,
        formData: {
          ...state.formData,
          campaign: payload,
        },
      };
       case RESET_INTEREST_FORM:
      return {
        ...state,
        formLevel: 0,
        age: 0,
        formData: {
          campaign: state.formData.campaign, // Keep campaign data
          studentFirstName: "",
          studentLastName: "",
          birthDate: "",
          parentRelationship: "",
          parentFirstName: "",
          parentLastName: "",
          primaryEmail: "",
          phone: "",
          street1: "",
          street2: "",
          state: "",
          charter: "",
          region: "",
          city: "",
          country: "",
          zipCode: "",
          sameAddress: false,
          mailingStreet1: "",
          mailingStreet2: "",
          mailingCity: "",
          mailingState: "",
          mailingRegion: "",
          mailingCountry: "",
          mailingZipCode: "",
          learningCenterName: state.formData.learningCenterName, // Keep learning center info
          learningCenterCharter: state.formData.learningCenterCharter,
          learningCenterAddress: state.formData.learningCenterAddress,
          charterWebsite: state.formData.charterWebsite,
          charterContactnumber: state.formData.charterContactnumber,
          brandIcon: state.formData.brandIcon,
          principal: state.formData.principal,
          learningCenterId: state.formData.learningCenterId,
          status: "New Interest",
          lastContactDate: "",
        },
        pass: {
          initial: true,
          parents: true,
          contact: true,
          address: true,
          mailing: true,
        },
      };
    default:
      return state;
  }
};

export default InterestReducer;
